import React, { useState, useEffect, Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Branch from "../images/branch.jpg";
import Mobilenav from "./mobiledropdwn";
import "./OurBranch.css";
import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import $ from 'jquery'
import Footer from "./footer";
import AOS from 'aos';


const client = new ApolloClient({
  link: new HttpLink({ uri: "https://pensure-cms.inspireleadership.biz/graphql"}),
  cache: new InMemoryCache(),
});



// Sample data - replace with your server data
const branchData = {
  western: [
    {
      id: 1,
      name: "Head Office",
      address: "121/123 Funsho Williams Avenue, Surulere, Lagos. Nigeria",
      email: "info@leadway-pensure.com",
      phone: "02-01-2800800, 0700-Pensure",
      branchManager: {
        name: "Peter Olawole",
        phone: "09096995096",
        email: "p-olawale@leadway-pensure.com",
      },
    },
    {
      id: 2,
      name: "Ibadan",
      address: "43, Osuntokun Avenue Beside Zenith Bank, Old Bodija, Ibadan",
      email: "info@leadway-pensure.com",
      phone: "09096998478 / 09096998485",
      branchManager: {
        name: "Ademola Ogunsan",
        phone: "08098895478",
        email: "a-ogunsan@leadway-pensure.com",
      },
    },
    {
      id: 3,
      name: "Ile-Ife",
      address: "Inside UBA, Obafemi Awolowo University Campus, Ile-Ife",
      email: "info@leadway-pensure.com",
      phone: "09096995046 / 08063144771",
      branchManager: {
        name: "Akin Ademola",
        phone: "08033896572",
        email: "a-akin@leadway-pensure.com",
      },
    },
  ],
  eastern: [
    {
      id: 4,
      name: "Enugu",
      address: "45 Ogui Road, Independence Layout, Enugu",
      email: "enugu@leadway-pensure.com",
      phone: "08098895500 / 08098895501",
      branchManager: {
        name: "Chioma Nwosu",
        phone: "08098895502",
        email: "c-nwosu@leadway-pensure.com",
      },
    },
  ],
  northern: [
    {
      id: 5,
      name: "Abuja",
      address: "Plot 123 Cadastral Zone, Central Business District, Abuja",
      email: "abuja@leadway-pensure.com",
      phone: "09098895600 / 09098895601",
      branchManager: {
        name: "Ibrahim Musa",
        phone: "09098895602",
        email: "i-musa@leadway-pensure.com",
      },
    },
  ],
  southern: [
    {
      id: 6,
      name: "Port Harcourt",
      address: "12 Aba Road, Port Harcourt, Rivers State",
      email: "portharcourt@leadway-pensure.com",
      phone: "08098895700 / 08098895701",
      branchManager: {
        name: "Blessing Amadi",
        phone: "08098895702",
        email: "b-amadi@leadway-pensure.com",
      },
    },
  ],
};
// Single reusable BranchCard component
const BranchCard = ({ branch }) => {

  return (
    <div className="card experience-crd pb-4" style={{ width: "350px" }}>
      <div className="d-flex flex-column gap-3 crd-bdy">
        <p id="ourbranch-p" className="grey-p grey-color">
          {branch.mapSearchName}
        </p>

        <hr style={{ width: "353px" }} className="crd-hr" />
        <p id="our-p" style={{ height: "50px" }} className="grey-p grey-color">
          {branch.officeAddress}
        </p>
        <p id="our-p" className="grey-p grey-color">
          {branch.emailAddress}
        </p>
        <p id="our-p" className="grey-p grey-color">
          {branch.phoneNo}
        </p>

        {branch.branchManager && (
          <>
            <p id="orng-lnk" className="orng-link mt-3">
              BRANCH MANAGER DETAILS
            </p>
            <p id="our-p" className="grey-p grey-color">
              {branch.branchManager}
            </p>
            <p id="our-p" className="grey-p grey-color">
              {branch.branchManagerPhone}
            </p>
            <p id="our-p" className="grey-p grey-color">
              {branch.branchManagerEmail}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

const BranchNetworkTabs = () => {
  const [activeTab, setActiveTab] = useState("west");
  const [westernState, setWesternState] = useState([]);
   const [northernState, setNorthernState] = useState([]);
    const [southernState, setSouthernState] = useState([]);
     const [easternState, setEasternState] = useState([]);
       const [states, setStates] = useState([]);



  

  const regions = [
    { key: "west", label: "Western Region" },
    { key: "east", label: "Eastern Region" },
    { key: "north", label: "Northern Region" },
    { key: "south", label: "Southern Region" },
  ];


const baseUrl = 'https://mapps.leadway-pensure.com/PensureWebsiteAPI/WebData/BranchLocation';
const url = new URL(baseUrl);

// Add query params to the URL
url.searchParams.append('clientId', '9dy8earw04r09wjefsdp90zsjs');

let west 
let north
let east 
let south

let branchData1

   function buttonCall() {
    const target = document.getElementById("desktop-only");
    target.scrollIntoView({ behavior: "smooth" });
  }


async function getBranchData() { 

 // alert('ran')
   window.scrollTo(0, 0)



const pushLeadDetails = await fetch(url, { 
            method:"POST",
            headers:{
              "content-type":"application/JSON"
            }
          })

          .then(response => response.json())
          .then(response => { 

            console.log(response)

            let branches
            let branchLocations
            let locations
           

             
            west = response.Data.filter(branch => 

             branch.location === 'Ekiti' || branch.location === 'Kwara' || branch.location === 'Lagos' || branch.location === 'Ogun' || branch.location === 'Ondo' || branch.location === 'Osun' || branch.location === 'Oyo'   
                )
                setWesternState( (westernState) => west )
                 setStates( (westernState) => west )

                
            east = response.Data.filter(branch => 

            branch.location === 'Abia' || branch.location === 'Anambra' || branch.location === 'Enugu' || branch.location === 'Imo' 
                   
                )

                  setEasternState( (easternState) => east )

            north = response.Data.filter(branch => 
            branch.location === 'Adamawa' || branch.location === 'Bauchi' || branch.location === 'Benue' || branch.location === 'Borno' || branch.location === 'FCT' || branch.location === 'Federal Capital Territory' || branch.location === 'Abuja' ||
            branch.location === 'Kaduna' || branch.location === 'Kano' || branch.location === 'Kogi' || branch.location === 'Niger' || branch.location === 'Plateau' || branch.location === 'Sokoto' || branch.location === 'Zamfara'  
                )

                setNorthernState( (northernState) => north )

            south = response.Data.filter(branch => 

            branch.location === 'Akwa-Ibom' || branch.location === 'Bayelsa' || branch.location === 'Cross River' || branch.location === 'Cross Rivers' || branch.location === 'Delta' || branch.location === 'Edo' || branch.location === 'Rivers'
                )
               setSouthernState( (southernState) => east )
        

       


            })

          //  statesList(activeTab)
    
    }

  
              useEffect( () => {
                                           AOS.init({
                                              offset: 0,
                                              duration: 1000,
                                              once: true
                                       });
                                                        
                                                            
                                       }, [])
  
   useEffect(() => {
    getBranchData()
      // alert('ran')
   window.scrollTo(0, 0)
        
        }, []) 
  


  function statesList(currentRegion) { 

    if(currentRegion === "west"){
      setStates((listState) => westernState)
      console.log(states)
    }

    if(currentRegion === "east"){
      setStates((listState) => easternState)
    }

     if(currentRegion === "north"){
      setStates((listState) => northernState)
    }

     if(currentRegion === "south"){
      setStates((listState) => southernState )
    }


   }

    

  return (
    <>
      <div className="leadership-container">
        <div className="leadership-cover">
          <img className="leadership-bg" src={Branch} />
          <div className="leadership-content">
            <div id="branch-txt" className="abt-text ldr-txt">
              <h1 id="lead-h1" className="lead-h1 " data-aos="zoom-in" data-aos-delay="200">
                Our Branch Network
              </h1>
              <p className="grey-p" data-aos="fade-up" data-aos-delay="200">
                Locate a Leadway Pensure office near you for in-person support
                and services.
              </p>
              <a id="btn-trns" className="btn-trns" onClick={buttonCall} data-aos="fade-up" data-aos-delay="200">
                {" "}
                Locate Nearest Office{" "}
                <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="containeer">
        {/* Bootstrap Tabs */}
        <Mobilenav
          items={[
            "Western Region",
            "Eastern Region",
            "Northern Region",
            "Southern Region",
          ]}
          activeItem={
            activeTab === "west"
              ? "Western Region"
              : activeTab === "east"
              ? "Eastern Region"
              : activeTab === "north"
              ? "Northern Region"
              : "Southern Region"
          }
          onSelect={(item) => {
            const key = item.toLowerCase().split(" ")[0];
            setActiveTab(key);
          }}
        />

        <div id="desktop-only" className="tabs-wrapper">
          <ul
            className="nav nav-tabs custom-tabs"
            id="regionTabs"
            role="tablist"
          >
            {regions.map((region) => (
              <li className="nav-item" role="presentation" key={region.key}>
                <button
                  className={`nav-link ${
                    activeTab === region.key ? "active" : ""
                  }`}
                  id={`${region.key}-tab`}
                  data-bs-toggle="tab"
                  data-bs-target={`#${region.key}`}
                  type="button"
                  role="tab"
                  aria-controls={region.key}
                  aria-selected={activeTab === region.key}
                  onClick={() => {
                    setActiveTab(region.key) 
                    statesList(region.key)
                  } }
                >
                  {region.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Tab Content */}
        <div className="tab-content col-12 col-md-11 mx-auto" id="regionTabContent" data-aos="zoom-in" data-aos-delay="200">
          {regions.map((region) => (
            <div
              key={region.key}
              className={`tab-pane fade  ${
                activeTab === region.key ? "show active" : ""
              }`}
              id={region.key}
              role="tabpanel"
              aria-labelledby={`${region.key}-tab`}
            >
              <div className="d-flex flex-wrap tab-branch-cards" >
                {states.map((branch) => (
                  <BranchCard key={branch.id} branch={branch} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
         <Footer/>
           <div className='height'> 

              </div>
    </>
  );

};

export default BranchNetworkTabs;
